export default {
    ADD_USER_TRIGGER: 'ADD_USER_TRIGGER',
    EDIT_USER_TRIGGER: 'EDIT_USER_TRIGGER',
    DELETE_USER_TRIGGER: 'DELETE_USER_TRIGGER',
    UPDATE_FULL_USER_TRIGGERS: 'UPDATE_FULL_USER_TRIGGERS',
    UPDATE_REORDERED_USERTRIGGERS: 'UPDATE_REORDERED_USERTRIGGERS',
    RESET_USER_TRIGGERS: 'RESET_USER_TRIGGERS'
};
